import React from 'react';

import CustomDropdown from '@components/CustomDropdown';

import { MOQ_UNIT } from '@features/materials/MaterialConstants';

import { changeDateFormat } from '@utils/Util';

const MaterialRoadmap = ({
	roadmapInput = [],
	onChangeMaterialRoadmap,
	suppliers,
	setRoadmapInput,
	selectedSupplier,
	errors,
	showTitle = true
}) => {
	const addSelectedSupplier = (selectedItem, index) => {
		setRoadmapInput((prev) => {
			const updatedInput = prev.map((item, i) => {
				if (i === index) {
					return {
						...item,
						supplier: selectedItem?.value,
						supplierId: selectedItem?.id
					};
				}
				return item;
			});
			return updatedInput;
		});
	};

	const addSelectedMoq = (selectedUnit, index) => {
		setRoadmapInput((prev) => {
			const updatedInput = prev.map((item, i) => {
				if (i === index) {
					return {
						...item,
						unit: selectedUnit?.value
					};
				}
				return item;
			});
			return updatedInput;
		});
	};

	return (
		<div>
			<div>
				<h3 className="semibold-14">
					{showTitle && 'MATERIAL ROADMAP'}
					<span className="regular-12 gray_dark_02 weight-400">
						{' '}
						(from where we can source this material)
					</span>
				</h3>{' '}
				{errors && <p className="error">{errors}</p>}
			</div>

			<div className="w-100 scroll-x-label">
				<table className="table with-border no-hover height-sm material-roadmap-table">
					<thead>
						<tr>
							<th>SL</th>
							<th>Supplier</th>
							<th>Lead time</th>
							<th>MOQ</th>
							<th> MOQ Unit</th>
							<th className="text-right">Unit Price: $</th>
							<th>Last updated</th>
							<th>Remarks</th>
						</tr>
					</thead>
					<tbody>
						{roadmapInput.map((row, index) => (
							<tr key={row.id}>
								<td>{index + 1}</td>
								<td className="supplier-column">
									{index === 0 ? (
										<p>{selectedSupplier?.value}</p>
									) : (
										<div className="transparent-select">
											<CustomDropdown
												items={suppliers}
												onItemClick={(value) => addSelectedSupplier(value, index)}
												selectedItem={row?.supplier}
												toolTipLength={14}
											/>
										</div>
									)}
								</td>
								<td className="lead-time-column">
									<input
										type="number"
										placeholder="In days"
										className="no-border pl-0"
										name="leadTime"
										value={row?.leadTime}
										onChange={(e) => onChangeMaterialRoadmap(e, row, index)}
									/>
								</td>
								<td className="qty-column">
									<input
										type="number"
										placeholder="Qty"
										className="no-border pl-0"
										name="moq"
										value={row?.moq}
										onChange={(e) => onChangeMaterialRoadmap(e, row, index)}
									/>
								</td>
								<td className="unit-column">
									<div className="transparent-select">
										<CustomDropdown
											items={MOQ_UNIT}
											isShowSearch={false}
											onItemClick={(value) => addSelectedMoq(value, index)}
											selectedItem={row?.unit}
										/>
									</div>
								</td>
								<td className="price-column">
									<input
										type="number"
										placeholder="$"
										className="no-border pl-0"
										name="unitPrice"
										value={row?.unitPrice}
										onChange={(e) => onChangeMaterialRoadmap(e, row, index)}
									/>
								</td>

								<td className="date-column">
									{row?.lastPriceModifiedAt &&
										changeDateFormat(
											row?.lastPriceModifiedAt,
											'YYYY-MM-DD',
											'DD MMM, YYYY'
										)}
								</td>
								<td className="remarks-column">
									<div>
										<textarea
											id="description"
											name="remarks"
											value={row?.remarks}
											onChange={(e) => onChangeMaterialRoadmap(e, row, index)}
										/>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default MaterialRoadmap;
